import { useJsApiLoader } from '@react-google-maps/api'

const googleMapsLibrairies: (
  | 'places'
  | 'drawing'
  | 'geometry'
  | 'localContext'
  | 'visualization'
)[] = ['places', 'drawing']

const useGoogleMapsLoader = (apiKey: string): boolean => {
  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: apiKey,
    libraries: googleMapsLibrairies,
  })

  return isLoaded
}

export default useGoogleMapsLoader
